import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrls: ['./otp-verify.component.scss']
})
export class OtpVerifyComponent implements OnInit {
  otp: any;

  constructor(private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) { }

  ngOnInit() {
  }

  verifyOTP() {
    var dObj = {
      userId: this.auth.getUserId(),
      otp: this.otp
    };
    var api = 'profile/validateOtp'
    this.cstemapi.cstemAPI(dObj).ValidateOTP.subscribe(data => {
      // console.log("ravi", data)
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {

        this.cstemapi.Swal.fire({
          title: 'Successfully Verified, Please login',
          type: 'success',
          confirmButtonText: 'OK',
        }).then((result) => {
          if (result.value) {
            this.myRoute.navigate([""]);
          }
        })
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Invalid OTP', '', 'error');
      }
      if (resData.statusCode == 'E004') {
        this.cstemapi.Swal.fire('OTP is Expired. Please click Resend button', '', 'error');
      }
    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  resendOtp() {
    if (this.auth.getUserId() != null || this.auth.getUserId() != undefined) {
      var dObj = {
        userId: this.auth.getUserId()
      };
      var api = 'profile/generateOtp'
      this.cstemapi.cstemAPI(dObj).GenerateOTP.subscribe(data => {
        this.cstemapi.printReqRes(dObj, data, api)
        let resData: any = data;
        if (resData.statusCode == 'S001') {
          this.myRoute.navigate(['otp']);
        }
        if (resData.statusCode == 'S001') {
          this.cstemapi.Swal.fire('Please check your e-mail for OTP', '', 'success');
        }
        if (resData.statusCode == 'E001') {
          this.cstemapi.Swal.fire("Error while resending OTP", "", "error");
        }

      }, (error) => {
        this.cstemapi.Swal.fire('Oops...', error, 'error');
      });
    } else {
      this.cstemapi.Swal.fire('Invalid Submission');
    }
  }

  getUserDetails() {
    var dObj = {
      userId: this.auth.getUserId()
    };
    var api = 'profile/getUserDetails'
    this.cstemapi.cstemAPI(dObj).UserInfo.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.auth.saveUserInfo(JSON.stringify(resData));
        this.myRoute.navigate(["chooseoption"]);
      }
      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error while getting user details', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }
}
